import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  InputGroup,
  Row,
  Spinner,
  Card,
} from 'react-bootstrap'
//import {AsideMenucommissionReports} from './components/AsideMenucommissionReports'
import {useLazyQuery, useQuery, useMutation} from '@apollo/client'
import {GET_COMMISSION_REPORT_PAYROLL} from '../../gql/queries/commissionReportsDetailsApiQueries'
import {GET_COMMISSION_REPORT_BY_ID_API} from '../../gql/queries/commissionReportsApiQueries'
import {useGetUser} from '../../store/userStore'
import {URL} from '../../gql/client'

import {toast} from 'react-toastify'
import {
  IResCommissionReportPayroll,
} from '../../types/commissionReportDetailApi'
import {hasPermission, parseId, parsePrice} from '../../helpers'
import moment from 'moment'


import {ModalEditCommissionReport} from '../commissionReports/components/ModalEditCommissionReport'
import {NodeCommissionReport} from '../../types/commissionReportApi'
import {TOGGLE_STATUS_COMMISSION_REPORT} from '../../gql/mutations/commissionReportMutations'
import {ModalConfirmation} from '../commissionReports/components/ModalConfirmation'
import {ALL_PERMISSIONS} from '../../helpers/consts'
import { GET_ALL_USERS_FILTER } from '../../gql/queries/usersQuery'
import { IResAllUsers } from '../oneUser/oneUserTypes'
import {PhoneProviderActions} from '../../components/telephony/PhoneProviderActions'

export const CommissionReportsPayrollPage = () => {
  const permissions = useGetUser((s) => s.user?.permissions)
  const canEditCommission =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.EDIT_COMMISSION)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const currentUserId = useGetUser((s) => s.user?.user?.id)
  const isAgente = userGroups.includes('Agente')

  // --- React Router
  const {id} = useParams<{id: string}>()
  const navigate = useNavigate()

  // --- Estado para el ID y nombre del reporte
  const [reportId, setReportId] = useState<string | null>(null)

  // --- GraphQL Hooks
  const [getOneCommissionReport, {data: commissionReportById}] = useLazyQuery(
    GET_COMMISSION_REPORT_BY_ID_API,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [
    gqlGetCommissionReportPayroll,
    {data: dataCommissionReportPayroll, loading, error, refetch: refetchEntries},
  ] = useLazyQuery<IResCommissionReportPayroll>(GET_COMMISSION_REPORT_PAYROLL, {
    fetchPolicy: 'no-cache',
  })

  const {data: dataMembers} = useQuery<IResAllUsers>(
    GET_ALL_USERS_FILTER,
    {
      fetchPolicy: 'no-cache',
      variables: {requireNpn: true},
    }
  )

  // --- Modales y UI
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [infoEdit, setInfoEdit] = useState<NodeCommissionReport | null>(null)

  // -- Reopen and close commission report for toggling status
  const [gqlToggleStatusCommissionReport] = useMutation(TOGGLE_STATUS_COMMISSION_REPORT)
  const [isOpenToggleModal, setIsOpenToggleModal] = useState(false)
  const [toggleAction, setToggleAction] = useState<'close' | 'reopen'>('close')

  const handleToggleStatus = async () => {
    if (!report?.id) return

    try {
      await gqlToggleStatusCommissionReport({
        variables: {
          id: parseId(report.id),
          newStatus: report.status === 'DRAFT' ? 'COMPLETED' : 'DRAFT',
        },
      })
      toast.success(
        report.status === 'DRAFT'
          ? 'Commission Report closed successfully'
          : 'Commission Report reopened successfully'
      )
      await refetchReport()
      await refetchEntries()
    } catch (error: any) {
      toast.error(`Error: ${error.message}`)
    } finally {
      setIsOpenToggleModal(false)
    }
  }

  // --- Filtros y paginación
  const [tabFilters] = useState('CommissionReportsDetails')
  const [valueUser, setValueUser] = useState(isAgente && currentUserId ? currentUserId : '')
  // Antes del useState

  type IFilterType = 'all' | 'COMMISSION' | 'DEDUCTION' | 'CHARGEBACK'

  const [filterType, setFilterType] = useState<IFilterType>('all')

  // --- Datos del detalle
  const [dataArr, setDataArr] = useState<IResCommissionReportPayroll['commissionReportPayroll']>([])

  const initialDetailData = {client: '', status: '', user: ''}
  const [detailData, setDetailData] = useState(initialDetailData)

  // --- Efecto para cargar reporte al inicio
  useEffect(() => {
    const decodedId = id ? String(parseId(id)) : null
    if (decodedId) {
      setReportId(decodedId)
      getOneCommissionReport({variables: {id: decodedId}})
    }
  }, [id, getOneCommissionReport])

  // --- Función para recargar reporte individual
  const refetchReport = async () => {
    if (reportId) {
      await getOneCommissionReport({
        variables: {id: reportId},
        fetchPolicy: 'no-cache',
      })
    }
  }

  // --- Obtener detalles del reporte con filtros
  const handleFilters = () => {
    const commissionReportId = id ? parseId(id) : null
    const userId = valueUser ? parseId(valueUser) : null

    gqlGetCommissionReportPayroll({
      variables: {
        client: detailData.client || null,
        status: 'APPROVED',
        commissionType: filterType === 'all' ? null : filterType,
        user: userId,
        commissionReport: commissionReportId,
      },
    })
  }

  useEffect(() => {
    handleFilters()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gqlGetCommissionReportPayroll, tabFilters])

  // --- Cargar datos de detalles y Validacion de totales
  const [totals, setTotals] = useState({
    approved: 0,
  })

  useEffect(() => {
    if (!dataCommissionReportPayroll) return

    const list = dataCommissionReportPayroll.commissionReportPayroll

    // Actualizar la tabla de datos
    setDataArr(list)

    // Actualizar los totales
    setTotals({
      approved: list.reduce((acc, item) => acc + parseFloat(item.totalAmount), 0),
    })
  }, [dataCommissionReportPayroll])

  // --- Manejo de errores
  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  const handleClientName = () => {
    handleFilters()
  }

  const user = useGetUser((s) => s.user)
  const [loadingExports, setLoadingExport] = useState(false)

  const safeParseId = (value: any): number | null => {
    const id = parseId(value) as number
    return !id || isNaN(id) || id === 0 ? null : id
  }

  const handleDownload = async () => {
    if (!user) return
    const {token} = user
    if (!token) return
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    const rawParams: Record<string, string | null | undefined> = {
      id: safeParseId(report.id)?.toString() ?? null,
    }

    const params = new URLSearchParams()

    Object.entries(rawParams).forEach(([key, value]) => {
      if (value != null && value !== '') {
        params.append(key, value)
      }
    })

    setLoadingExport(true)
    // setTimeout(() => {
    //   setLoadingExport(false)
    // }, 5000)
    try {
      const url = `${URL}/export-commission-payroll-excel?${params.toString()}`
      console.log('Export URL:', url)
      // const url = `${URL}/export-policy-excel?${params.toString()}`
      const res = await fetch(url, requestOptions)
      if (!res.ok) throw new Error('Error al exportar')
      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `${report.name} - payroll - ${moment().format('YY-MM-DD')}.xlsx`
      document.body.appendChild(link)
      setLoadingExport(false)
      link.click()
    } catch (err) {
      setLoadingExport(false)
      toast.error(`ERROR: ${(err as {message: string}).message}`)
    }
  }

  // --- Validación de carga
  if (!commissionReportById || !commissionReportById.commissionReportById) {
    return (
      <div className='d-flex flex-center' style={{height: '30vh'}}>
        <Spinner animation='border' />
      </div>
    )
  }

  // --- Report listo
  const report = commissionReportById.commissionReportById

  // --- Render principal (return) se mantiene igual ---
  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='fs-3' onClick={(e) => navigate('/commissions')}>
            Reports List
          </Breadcrumb.Item>
          <Breadcrumb.Item className='fs-3'>Payroll</Breadcrumb.Item>
        </Breadcrumb>
        <div className='policies-summary summary-cards mb-3'>
          <Card className='card-summary green flex-fill mx-2 text-center'>
            <Card.Title>Approved Total Amount</Card.Title>
            <Card.Body>
              {loading && <Spinner animation='border' />}
              {parsePrice(totals.approved ?? 0)}
            </Card.Body>
          </Card>
        </div>
      </header>
      <Row className='commissionReports'>
        <Col className='container'>
          <div className='policies-container'>
            <div className='title-header'>
              <h3>
                Report: {report.name}{' '}
                {canEditCommission && (
                  <span
                    style={{cursor: 'pointer'}}
                    className='text-primary ms-2'
                    onClick={() => {
                      setInfoEdit(report)
                      setIsOpenEdit(true)
                    }}
                  >
                    <i className='bi bi-pencil-square' /> Edit
                  </span>
                )}
                <br />
                <small>
                  Date:{' '}
                  {report.effectiveMonth && report.effectiveYear
                    ? moment(
                        `${report.effectiveYear}-${report.effectiveMonth}-01`,
                        'YYYY-MM-DD'
                      ).format('MMMM YYYY')
                    : ''}
                </small>
              </h3>

              <div className='d-flex gap-2 align-items-center'>
                <Button size='sm' onClick={() => navigate(`/commissions/${report.id}/details`)}>
                  <>
                    <i className='bi bi-list-check' /> See details
                  </>
                </Button>

                {canEditCommission && (
                  <>
                    <Button disabled={loadingExports} size='sm' onClick={handleDownload}>
                      {loadingExports ? (
                        <>
                          <Spinner animation='border' size='sm' />{' '}
                        </>
                      ) : (
                        <i className='bi bi-download'></i>
                      )}
                      Export
                    </Button>
                    <Button
                      size='sm'
                      variant={report.status === 'DRAFT' ? 'danger' : 'success'}
                      className='ms-2'
                      onClick={() => {
                        setToggleAction(report.status === 'DRAFT' ? 'close' : 'reopen')
                        setIsOpenToggleModal(true)
                      }}
                    >
                      {report.status === 'DRAFT' ? (
                        <>
                          <i className='bi bi-lock-fill' /> Finish and Close Report
                        </>
                      ) : (
                        <>
                          <i className='bi bi-unlock-fill' /> Reopen Report
                        </>
                      )}
                    </Button>
                  </>
                )}
              </div>
            </div>

            <div className='filters-header'>
              <InputGroup>
                <Form.Control
                  placeholder='Filter by client name'
                  aria-label="Client's name with two button addons"
                  onChange={(e) =>
                    setDetailData((prev) => ({
                      ...prev,
                      client: e.target.value,
                    }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleClientName()
                    }
                  }}
                  value={detailData.client}
                  disabled={false}
                />

                <Form.Select
                  value={filterType}
                  aria-label='Filter by Type'
                  onChange={(e) => setFilterType(e.target.value as IFilterType)}
                  className='ms-2'
                >
                  <option value='all'>Filter by Type</option>
                  <option value='COMMISSION'>Commission</option>
                  <option value='DEDUCTION'>Deduction</option>
                  <option value='CHARGEBACK'>Chargeback</option>
                </Form.Select>

                <Form.Select
                  aria-label='Filter by Agent'
                  name='userFilter'
                  className='ms-2'
                  value={valueUser}
                  onChange={(e) => {
                    const {value} = e.target
                    setValueUser(value)
                  }}
                  disabled={isAgente}
                >
                  <option value=''>Filter by Agent</option>
                  {dataMembers?.allUsers.edges.map(({node}) => (
                    <option key={node.id} value={node.id}>
                      {node.firstName +
                        ' ' +
                        node.lastName +
                        ' - ' +
                        node.email +
                        (node.npn ? ' (' + node.npn + ')' : '')}
                    </option>
                  ))}
                </Form.Select>
                <Button
                  disabled={false}
                  onClick={() => handleFilters()}
                  variant='outline-success'
                  style={{border: '1px solid #dbdfe9'}}
                  className='ms-2'
                >
                  Search
                </Button>
              </InputGroup>
            </div>
            <div className='results-header'>
              <div className='col-md-3'>
                <div className='results-filter'>
                  <Col lg={12} md={12} sm={12} xs={12}></Col>
                </div>
              </div>
            </div>

            <div className='table-responsive table table-striped table-hover '>
              <table
                className='table-scrollable table-scroll  table table-striped table-hover '
                style={{whiteSpace: 'nowrap'}}
              >
                <thead>
                  <tr role='row'>
                    <th className='fw-bold'>Agent</th>
                    <th className='fw-bold'>Email</th>
                    <th className='fw-bold'>NPN</th>
                    <th className='fw-bold'>Cellphone</th>
                    <th className='fw-bold'>Total Amount</th>
                  </tr>
                </thead>

                {loading || !dataCommissionReportPayroll ? (
                  <tbody>
                    <tr>
                      <td colSpan={5}>
                        <div className='d-flex flex-center' style={{height: '30vh'}}>
                          <Spinner animation='border' />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {dataArr.length === 0 ? (
                      <tr>
                        <td colSpan={5}>
                          <div className='d-flex flex-center' style={{height: '30vh'}}>
                            There are no commission payroll records available
                          </div>
                        </td>
                      </tr>
                    ) : (
                      dataArr.map((item, index) => (
                        <tr key={item.user.id || index}>
                          <td>
                            {item.user.firstName} {item.user.lastName}
                          </td>
                          <td>{item.user.email}</td>
                          <td>{item.user.npn}</td>
                          <td>
                            <PhoneProviderActions phone={item.user.cellphone} />
                          </td>
                          <td>{parsePrice(item.totalAmount)}</td>
                        </tr>
                      ))
                    )}
                    <tr>
                      <td colSpan={4} style={{textAlign: 'right', fontWeight: 'bold'}}>
                        Grand Total:
                      </td>
                      <td style={{fontWeight: 'bold'}}>
                        {parsePrice(
                          dataArr.reduce((acc, item) => acc + parseFloat(item.totalAmount), 0)
                        )}
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </Col>
      </Row>

      {/*
      showAside && (
        <AsideMenucommissionReports
          isOpen={showAside}
          onClose={() => setShowAside(false)}
          tabFilters={tabFilters}
          setTabFilters={setTabFilters}
        />
      )
      */}

      {isOpenEdit && infoEdit && (
        <ModalEditCommissionReport
          isOpen={isOpenEdit}
          onClose={() => {
            setIsOpenEdit(false)
          }}
          infoEdit={infoEdit}
          refetch={refetchReport}
        />
      )}

      {isOpenToggleModal && (
        <ModalConfirmation
          isOpen={isOpenToggleModal}
          onClose={() => setIsOpenToggleModal(false)}
          onConfirm={handleToggleStatus}
          refetch={refetchEntries}
          title={toggleAction === 'close' ? 'Close Report' : 'Reopen Report'}
          confirmText={toggleAction === 'close' ? 'Yes, Close Report' : 'Yes, Reopen Report'}
          confirmVariant={toggleAction === 'close' ? 'danger' : 'success'}
          body={
            toggleAction === 'close' ? (
              <>
                <p>
                  <strong>Are you sure you wish to close this report?</strong>
                </p>
                <ul>
                  <li>
                    All <strong>PENDING</strong> policies will be marked as{' '}
                    <strong>NOT ASSIGNED</strong>.
                  </li>
                  <li>You confirm the rates and assignments are final.</li>
                </ul>
              </>
            ) : (
              <p>
                <strong>Are you sure you want to reopen this report?</strong>
                <br />
                All <strong>NOT ASSIGNED</strong> policies will be marked as{' '}
                <strong>PENDING</strong>.
              </p>
            )
          }
        />
      )}
    </div>
  )
}
